import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getModuleStatus } from '../../store/ModuleStatusAction';
import { subscribe } from '../../store/NotificationAction';
import * as Helper from '../../util/Helper';
import StatusCode from '../../util/StatusCode';
import TableHorizontal, { InfoObject } from '../misc/TableHorizontal';
import Pagination from '../misc/Pagination';
import { useParams, Link } from 'react-router-dom';
import DownloadFilesForInstance from "./components/DownloadFilesForInstance";
import { useTranslation } from 'react-i18next';
import { CoreModuleStatus } from "../../models/CoreModels";
import { RequestState } from "../../models/RequestState";
import * as Notifications from '../../services/Notifications'
import { getInstances, InstanceRequestState } from "../../store/ModuleInstanceAction";
import { RootState } from "../../store/store";



const ModuleInstanceRun = () => {
    const { moduleId } = useParams();
    const dispatch = useDispatch();
    const [lastMessageId, setMessageId] = useState<string | undefined>(undefined);

    const instances = useSelector<RootState, InstanceRequestState>(state => state.moduleInstance.instances);
    const notification = useSelector<RootState, Partial<Notifications.NotificationServiceMessage>>(state => state.notification);
    const moduleStatus = useSelector<RootState, RequestState<CoreModuleStatus>>(state => state.moduleStatus.moduleStatus);

    const { t } = useTranslation('configuration');

    useEffect(() => {
        if (moduleId) {
            getInstances(moduleId, {})(dispatch);
            getModuleStatus(moduleId, true)(dispatch);
            return subscribe(['moduleInstanceStart', 'moduleInstanceComplete'])(dispatch);
        }
    }, [dispatch, moduleId]);

    useEffect(() => {
        if (instances.code === StatusCode.COMPLETE && lastMessageId !== notification.messageId) {
            setMessageId(notification.messageId);
            if (moduleId) {
                getInstances(moduleId, instances.filter)(dispatch);
            }
        }
    })

    const onChangePage = (p: number) => {
        if (moduleId) {
            getInstances(moduleId, { ...instances.filter, page: p })(dispatch);
        }
    }

    const dropdownMenu = (moduleInstanceId: string, completed: string | undefined) => {
        if (moduleId !== undefined && moduleStatus.code === StatusCode.COMPLETE) {
            return (<DownloadFilesForInstance
                moduleInstanceId={moduleInstanceId}
                completed={completed !== undefined ? true : false}
                fileDownloadEnabled={moduleStatus.data?.fileDownloadEnabled}
                moduleId={moduleId}
            />);
        }
        return '';
    }

    const mapInstances = (): InfoObject[] => {
        if (instances.code === StatusCode.COMPLETE) {
            return instances.data.values.map(instance => ({
                id: instance.id,
                data: [
                    { value: Helper.formatDate(instance.startedAt) },
                    { value: Helper.formatDate(instance.completedAt) },
                    { value: instance.countCritical ?? (instance.completedAt === undefined ? '' : '?') },
                    { value: instance.countError ?? (instance.completedAt === undefined ? '' : '?') },
                    { value: instance.countWarning ?? (instance.completedAt === undefined ? '' : '?') },
                    { value: <Link to={`/module/${moduleId}/instance/${instance.id}`}>{t('moduleInstanceRun.showLogs')}</Link> },
                    { value: dropdownMenu(instance.id, instance.completedAt) }
                ]
            }));
        } else {
            return [];
        }
    }

    return (<>
        <TableHorizontal
            header={[{ value: t('moduleInstanceRun.started') }, { value: t('moduleInstanceRun.ended') }, { value: t('moduleInstanceRun.criticalErrors') }, { value: t('moduleInstanceRun.errors') }, { value: t('moduleInstanceRun.warnings') }, { value: t('moduleInstanceRun.logs') }, { value: '' }]}
            info={mapInstances()}
            error={instances.code === StatusCode.ERROR}
            searching={instances.code === StatusCode.PENDING}
        />
        {instances.code === StatusCode.COMPLETE &&
            <Pagination requestState={instances} onChangePage={(p) => onChangePage(p)} className="no-padding" />
        }
    </>);
}

export default ModuleInstanceRun;
